import { transformerRegistry } from '@nextgen-web-framework/all';
import { productListViewTransformer, productViewTransformer } from '@commerce-product-webcomponents/sdk';
import { searchViewTransformer } from '@commerce-search-webcomponents/sdk';
import { EventNameEnum } from './types/propTypes';
import CartLinkTransformer from './transformers/CartLinkTransformer';
import SharebarTransformer from './transformers/SharebarTransformer';
import { TEALIUM_TOPICS } from './utils/constant';

const updateTransformerRegistry = () => {
  transformerRegistry[TEALIUM_TOPICS.cart_addition] = CartLinkTransformer;
  transformerRegistry[TEALIUM_TOPICS.cart_remove] = CartLinkTransformer;
  transformerRegistry[EventNameEnum.product_view] = productViewTransformer;
  transformerRegistry[EventNameEnum.onsite_search] = searchViewTransformer;
  transformerRegistry[EventNameEnum.product_list_view] = productListViewTransformer;
  transformerRegistry[TEALIUM_TOPICS.sharebar_publish] = SharebarTransformer;
  transformerRegistry[TEALIUM_TOPICS.onsite_search] = searchViewTransformer;
};

export default updateTransformerRegistry;
